<template>
  <div class="flex items-center justify-between w-full ">
    <span class="!text-gray-700 !font-semibold !text-sm">{{ displayName || label }}</span>
    <button class="blank circle-icon grid-diff-context-icon" @click="handleClick">
      <span class="sr-only">{{ displayName || label }}</span>
      <span class="text-gray-400" v-html="DOTS_VERTICAL_ROUNDED_ICON_SVG"></span>
    </button>
  </div>
</template>

<script setup lang="ts">
import type { GridApi } from 'ag-grid-enterprise';
import { DOTS_VERTICAL_ROUNDED_ICON_SVG } from '~/composables/aggrid-icons';

interface GridDiffIconParams {
  api: GridApi;
  iconClass?: string;
  label?: string;
  displayName?: string;
}

const props = defineProps<{
  params: GridDiffIconParams;
}>();

const { label, displayName } = props.params;

const handleClick = (event: MouseEvent) => {
  props.params.api.showContextMenu({
    rowNode: null,
    value: undefined,
    x: event.clientX,
    y: event.clientY,
    source: 'ui'
  });
};
</script>

<style>
.grid-diff-context-icon {
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}

.grid-diff-context-icon:hover {
  background: transparent;
}

.header-ctx-line.left-column-gap.has-icon:hover .grid-diff-context-icon {
  opacity: 1;
}
</style>